import { OrientationType } from "react-native-orientation-locker";
export const isPortraitUpsidedown = (o) => o === OrientationType['PORTRAIT-UPSIDEDOWN'];
//# sourceMappingURL=isPortraitUpsidedown.js.map